/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_Floor_Plans_Legal_DocsInputs */

const en_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload floor plans, legal docs, or detailed specs. Our AI uses RAG to "read" these files and provide factual answers to buyers.`)
};

const es_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube planos de planta, documentos legales o especificaciones detalladas. Nuestra IA usa RAG para "leer" estos archivos y proporcionar respuestas basadas en datos a los compradores.`)
};

const fr_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez des plans d'étage, des documents légaux ou des spécifications détaillées. Notre IA utilise la méthode RAG pour "lire" ces fichiers et fournir des réponses factuelles aux acheteurs.`)
};

const de_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade Grundrisse, rechtliche Dokumente oder detaillierte Spezifikationen hoch. Unsere KI nutzt RAG, um diese Dateien zu "lesen" und Käufern faktenbasierte Antworten zu geben.`)
};

const ja_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`間取り図、法的文書、または詳細な仕様書をアップロードしてください。当社のAIはRAGを使用してこれらのファイルを「読み取り」、購入者に事実に基づいた回答を提供します。`)
};

const zh_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传平面图、法律文档或详细规格说明。我们的 AI 将使用 RAG 技术“阅读”这些文件，并为买家提供基于事实的回答。`)
};

const ar_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم برفع مخططات الطوابق، المستندات القانونية أو المواصفات التفصيلية. يستخدم الذكاء الاصطناعي لدينا تقنية RAG لـ "قراءة" هذه الملفات وتقديم إجابات واقعية للمشترين.`)
};

const id_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah denah lantai, dokumen hukum, atau spesifikasi terperinci. AI kami menggunakan RAG untuk "membaca" file ini dan memberikan jawaban faktual kepada pembeli.`)
};

const it_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica planimetrie, documenti legali o specifiche dettagliate. La nostra IA utilizza il RAG per "leggere" questi file e fornire risposte basate sui fatti agli acquirenti.`)
};

const ru_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите планы этажей, юридические документы или подробные спецификации. Наш ИИ использует RAG для «чтения» этих файлов и предоставляет покупателям ответы, основанные на фактах.`)
};

const pt_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça upload de plantas baixas, documentos legais ou especificações detalhadas. Nossa IA usa RAG para "ler" esses arquivos e fornecer respostas baseadas em fatos aos compradores.`)
};

const ko_upload_floor_plans_legal_docs = /** @type {(inputs: Upload_Floor_Plans_Legal_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`평면도, 법적 문서 또는 상세 사양서를 업로드하세요. 당사의 AI는 RAG를 사용하여 이러한 파일을 '읽고' 구매자에게 사실에 기반한 답변을 제공합니다.`)
};

/**
* | output |
* | --- |
* | "Upload floor plans, legal docs, or detailed specs. Our AI uses RAG to \"read\" these files and provide factual answers to buyers." |
*
* @param {Upload_Floor_Plans_Legal_DocsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_floor_plans_legal_docs = /** @type {((inputs?: Upload_Floor_Plans_Legal_DocsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_Floor_Plans_Legal_DocsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_floor_plans_legal_docs(inputs)
	if (locale === "es") return es_upload_floor_plans_legal_docs(inputs)
	if (locale === "fr") return fr_upload_floor_plans_legal_docs(inputs)
	if (locale === "de") return de_upload_floor_plans_legal_docs(inputs)
	if (locale === "ja") return ja_upload_floor_plans_legal_docs(inputs)
	if (locale === "zh") return zh_upload_floor_plans_legal_docs(inputs)
	if (locale === "ar") return ar_upload_floor_plans_legal_docs(inputs)
	if (locale === "id") return id_upload_floor_plans_legal_docs(inputs)
	if (locale === "it") return it_upload_floor_plans_legal_docs(inputs)
	if (locale === "ru") return ru_upload_floor_plans_legal_docs(inputs)
	if (locale === "pt") return pt_upload_floor_plans_legal_docs(inputs)
	return ko_upload_floor_plans_legal_docs(inputs)
});